import { render, staticRenderFns } from "./Departemen.vue?vue&type=template&id=31c79308"
import script from "./Departemen.vue?vue&type=script&lang=js"
export * from "./Departemen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports